module.exports = __webpack_public_path__ + "img/partner_img19.6fdccf0f.png";